<!-- ============================================================ -->
<!-- DESKTOP VIEW (md y superior) — layout original con tablas   -->
<!-- ============================================================ -->
<div class="hidden md:block p-6 min-h-screen" style="zoom: 0.9">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
    <h3 class="font-bold">{{ '::Communications' | abpLocalization }}</h3>
    <div class="flex gap-2">
      <app-metro-button variant="secondary" text="{{ '::CreateCommunication' | abpLocalization }}" (clicked)="openCreateModal()">
      </app-metro-button>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="flex flex-col md:flex-row gap-2 mb-8 items-center">
    <div class="w-full [&_input::placeholder]:normal-case mb-1">
      <app-metro-search-input (search)="onSearch($event)" (cleared)="onClearSearch()"></app-metro-search-input>
    </div>
  </div>

  <!-- Table Section -->
  <div class="overflow-x-auto w-full min-w-0">
    @if (isLoading) {
    <div class="p-8">
      <app-metro-table-skeleton [columns]="columns"></app-metro-table-skeleton>
    </div>
    } @else {
    <app-metro-table [columns]="columns" [data]="data.items" [actions]="actions" [actionsMenu]="true" [pageSize]="maxResultCount"
      [(currentPage)]="currentPage" (pageChange)="onPageChange($event)" [isServerPaginated]="true"
      [totalItems]="data.totalCount">
    </app-metro-table>
    }
  </div>
</div>


<!-- ============================================================ -->
<!-- MOBILE VIEW (menos de md) — layout con tarjetas              -->
<!-- ============================================================ -->
<div class="md:hidden min-h-screen px-4 pt-6 pb-24 overflow-x-hidden" style="zoom: 0.9">

  <!-- Header -->
  <div class="mb-5">
    <h3 class="font-bold mb-2">{{ '::Communications' | abpLocalization }}</h3>
    <div class="flex items-center gap-2">
      <button (click)="openCreateModal()"
        class="px-3 py-2 border border-gray-300 bg-white rounded-xl text-sm font-semibold text-gray-800 whitespace-nowrap">
        {{ '::CreateCommunication' | abpLocalization }}
      </button>
    </div>
  </div>

  <!-- Search -->
  <div class="relative mb-5">
    <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none">
      <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
      </svg>
    </div>
    <input type="text" [placeholder]="'::Search' | abpLocalization" (input)="onSearch($any($event.target).value)"
      class="w-full pl-11 pr-4 py-3 bg-gray-100 rounded-2xl text-sm font-medium text-gray-800 placeholder:text-gray-400 border-0 focus:outline-none focus:ring-2 focus:ring-gray-200" />
  </div>

  <!-- List Cards -->
  @if (isLoading) {
  <div class="space-y-4">
    @for (i of [1,2,3]; track i) {
    <div class="h-40 bg-gray-100 rounded-2xl animate-pulse"></div>
    }
  </div>
  } @else {
  <div class="space-y-4">
    @for (item of data.items; track item.id) {
    <div class="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm">

      <div class="px-4 py-4">
        <!-- Message -->
        <div class="mb-4">
          <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Message' | abpLocalization }}</p>
          <p class="text-sm font-bold text-gray-900 leading-snug break-words">{{ item.message }}</p>
        </div>

        <!-- Meta Grid -->
        <div class="grid grid-cols-2 gap-4">
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::CreationTime' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700 leading-snug">{{ item.creationTimeDisplay }}</p>
          </div>
          <div class="min-w-0 overflow-hidden">
            <p class="text-[10px] text-gray-400 mb-1">{{ '::Status' | abpLocalization }}</p>
            <span [ngClass]="item.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'"
              class="inline-block px-2 py-0.5 rounded-full text-[10px] font-bold max-w-full">
              {{ (item.isActive ? '::IsActive' : '::Inactive') | abpLocalization }}
            </span>
          </div>
        </div>
      </div>

      <!-- Action Bar -->
      <div class="border-t border-gray-100 grid grid-cols-3 divide-x divide-y divide-gray-100">
        <button (click)="openEditModal(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-gray-600 hover:bg-gray-50 transition-colors">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {{ '::Edit' | abpLocalization }}
        </button>
        <button (click)="toggleActive(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-gray-600 hover:bg-gray-50 transition-colors">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="12" x2="16" y2="12" stroke-linecap="round" />
          </svg>
          {{ (item.isActive ? '::Deactivate' : '::Activate') | abpLocalization }}
        </button>
        <button (click)="deleteCommunication(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-red-600 hover:bg-red-50 transition-colors">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          {{ '::Delete' | abpLocalization }}
        </button>
      </div>
    </div>
    }
  </div>

  <!-- Pagination -->
  @if (data.totalCount > 0) {
  <div class="mt-6 flex items-center justify-between">
    <span class="text-sm font-semibold text-blue-500">{{ data.totalCount }} {{ '::Total' | abpLocalization }}</span>
    <div class="flex items-center gap-1">
      <button (click)="onPageChange(1)" [disabled]="currentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">«</button>
      <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">‹</button>
      @for (p of getPageNumbers(); track p) {
      <button (click)="onPageChange(p)"
        [class]="currentPage === p ? 'bg-gray-900 text-white font-bold' : 'text-gray-500 font-medium'"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-sm transition-all">
        {{ p }}
      </button>
      }
      <button (click)="onPageChange(currentPage + 1)" [disabled]="data.totalCount <= currentPage * maxResultCount"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">›</button>
      <button (click)="onPageChange(getTotalPages())" [disabled]="currentPage === getTotalPages()"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">»</button>
    </div>
  </div>
  }
  @if (data.totalCount === 0) {
  <div class="py-16 text-center text-gray-400 text-sm">
    No hay anuncios o mensajes creados
  </div>
  }
  }

</div>
